/* Illustrative materials and moving studio lighting. No image data leaves the browser. */
window.StickerMaterials = (() => {
  const names = {vinile:'vinile',olografico:'olografico',trasparente:'trasparente',glitter:'glitter',specchio:'specchio','alluminio spazzolato':'alluminio',riflettente:'riflettente','vinile removibile':'removibile','vinile rimovibile':'removibile'};
  const key = name => names[String(name || '').trim().toLocaleLowerCase('it').replace(/\s+/g,' ')] || '';
  const clamp = n => Math.max(-1,Math.min(1,Number(n)||0));
  const make = () => {const c=document.createElement('canvas');c.width=c.height=900;return c;};
  const surface=make(), ctx=surface.getContext('2d');
  const grains=new Map();
  const flakes=[];
  let seed=39127;
  const random=()=>{seed=(seed*1664525+1013904223)>>>0;return seed/4294967296;};
  for(let i=0;i<1800;i++) flakes.push([random()*900,random()*900,1+random()*2.5,random()*Math.PI*2,random()]);
  function grain(type) {
    if(grains.has(type))return grains.get(type);
    const c=make(),g=c.getContext('2d');
    if(type==='alluminio'){
      for(let y=0;y<900;y++){
        g.fillStyle=`rgba(${y%3?'255,255,255':'20,28,34'},${.025+random()*.08})`;
        g.fillRect(random()*30,y,900,random()*.65+.25);
      }
    }else{
      for(let i=0;i<22000;i++){
        const v=100+Math.floor(random()*150);
        g.fillStyle=`rgba(${v},${v+2},${Math.min(255,v+7)},${.25+random()*.5})`;
        g.fillRect(random()*900,random()*900,.6+random()*2,.6+random()*2);
      }
    }
    grains.set(type,c);return c;
  }
  function gradient(stops,x,y) {
    const g=ctx.createLinearGradient(-150+x*210,60+y*120,1050+x*210,720-y*160);
    stops.forEach(([p,c])=>g.addColorStop(p,c));ctx.fillStyle=g;ctx.fillRect(0,0,900,900);
  }
  function light(x,y,strength=.7,radius=480) {
    const g=ctx.createRadialGradient(350+x*310,240+y*300,0,350+x*310,240+y*300,radius);
    g.addColorStop(0,`rgba(255,255,255,${strength})`);g.addColorStop(.3,`rgba(255,255,255,${strength*.32})`);g.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=g;ctx.fillRect(0,0,900,900);
  }
  function texture(type,view) {
    const x=clamp(view.x),y=clamp(view.y);ctx.clearRect(0,0,900,900);
    if(type==='olografico'){
      gradient([[0,'#707b87'],[.25,'#eff5f7'],[.48,'#a6b4c2'],[.7,'#fff'],[1,'#788491']],x,y);
      ctx.save();ctx.globalCompositeOperation='color';ctx.globalAlpha=.84;
      const g=ctx.createLinearGradient(-280+x*430,100+y*270,1180+x*430,850-y*220);
      const phase=195+x*95-y*65;
      for(let i=0;i<=12;i++)g.addColorStop(i/12,`hsl(${phase+i*58},90%,62%)`);
      ctx.fillStyle=g;ctx.fillRect(0,0,900,900);ctx.restore();light(x,y,.65,510);
    }else if(type==='specchio'){
      gradient([[0,'#343c47'],[.18,'#b8c2cc'],[.29,'#f8fbff'],[.37,'#fff'],[.4,'#6c7785'],[.53,'#343e4c'],[.58,'#c3ccd5'],[.7,'#fff'],[.8,'#eef3f7'],[1,'#667380']],x,y);
    }else if(type==='alluminio'){
      gradient([[0,'#6a7279'],[.24,'#b4bec5'],[.47,'#eef2f5'],[.57,'#a2adb5'],[.85,'#dce3e7'],[1,'#7b8791']],x,y);
      ctx.drawImage(grain(type),0,0);light(x,y,.22,630);
    }else if(type==='glitter'){
      gradient([[0,'#79818b'],[.45,'#d8dce3'],[1,'#929eac']],x,y);ctx.drawImage(grain(type),0,0);
      for(const [fx,fy,size,angle,phase] of flakes){
        const glint=Math.pow(Math.max(0,Math.cos(angle+x*3.2+y*2.4)),18);
        ctx.fillStyle=`hsla(${205+phase*100},${12+phase*25}%,${55+glint*45}%,${.4+glint*.6})`;
        ctx.save();ctx.translate(fx,fy);ctx.rotate(angle);ctx.fillRect(-size,-size,size*2,size*2);
        if(glint>.94&&size>2.8){ctx.fillStyle='rgba(255,255,255,.9)';ctx.fillRect(-size*2.8,-.45,size*5.6,.9);ctx.fillRect(-.45,-size*2.8,.9,size*5.6);}
        ctx.restore();
      }
      light(x,y,.2,540);
    }else if(type==='riflettente'){
      gradient([[0,'#929da9'],[.55,'#bec8d2'],[1,'#8f9ba8']],x,y);ctx.globalAlpha=.15;ctx.drawImage(grain(type),0,0);ctx.globalAlpha=1;light(x,y,.97,610);
    }else if(type==='trasparente'){
      gradient([[0,'rgba(181,211,225,.035)'],[.31,'rgba(255,255,255,.025)'],[.44,'rgba(255,255,255,.26)'],[.49,'rgba(255,255,255,.09)'],[.57,'rgba(255,255,255,.025)'],[1,'rgba(179,205,221,.06)']],x,y);
    }
    return surface;
  }
  function paint(canvas,name,view={x:0,y:0}) {
    const type=key(name);if(!type||type==='vinile'||type==='removibile')return;
    const g=canvas.getContext('2d');g.save();g.setTransform(1,0,0,1,0,0);g.globalCompositeOperation='source-in';g.drawImage(texture(type,view),0,0);g.restore();
  }
  function sheen(canvas,name,view={x:0,y:0}) {
    const type=key(name);if(!type)return;
    const g=canvas.getContext('2d'),x=clamp(view.x),y=clamp(view.y);
    g.save();g.globalCompositeOperation='source-atop';
    const l=g.createLinearGradient(-120+x*300,100+y*200,1000+x*300,700-y*120);
    const a=type==='specchio'?.19:type==='trasparente'?.12:.08;
    l.addColorStop(0,'rgba(255,255,255,0)');l.addColorStop(.37,'rgba(255,255,255,0)');l.addColorStop(.49,`rgba(255,255,255,${a})`);l.addColorStop(.6,'rgba(255,255,255,0)');l.addColorStop(1,'rgba(255,255,255,0)');g.fillStyle=l;g.fillRect(0,0,900,900);g.restore();
  }
  return {key,paint,sheen};
})();

/* Palette and effect masks are calculated locally from visible pixels, never uploaded for analysis. */
window.StickerColorEffects = (() => {
  const distance = (a,b) => (a[0]-b[0])**2 + (a[1]-b[1])**2 + (a[2]-b[2])**2;
  const hex = rgb => '#' + rgb.map(v=>Math.round(v).toString(16).padStart(2,'0')).join('');
  const nearest = (rgb, palette) => {
    let best=0,score=Infinity;
    palette.forEach((entry,i)=>{const d=distance(rgb,entry.rgb);if(d<score){score=d;best=i;}});
    return best;
  };
  function detect(data, limit=12) {
    const bins=new Map();
    for(let i=0;i<data.length;i+=4){
      if(data[i+3]<24)continue;
      const id=(data[i]>>4)*256+(data[i+1]>>4)*16+(data[i+2]>>4),w=data[i+3]/255;
      let b=bins.get(id);if(!b){b={rgb:[0,0,0],weight:0};bins.set(id,b);}
      b.weight+=w;for(let c=0;c<3;c++)b.rgb[c]+=data[i+c]*w;
    }
    const points=[...bins.values()].map(b=>({rgb:b.rgb.map(v=>v/b.weight),weight:b.weight})).sort((a,b)=>b.weight-a.weight);
    if(!points.length)return [];
    const centers=[{rgb:[...points[0].rgb]}];
    // Weight keeps JPEG noise from becoming its own swatch; distance preserves distinct small accents.
    while(centers.length<limit){
      let candidate=null,best=0;
      for(const p of points){const d=distance(p.rgb,centers[nearest(p.rgb,centers)].rgb);const score=d*Math.sqrt(p.weight);if(d>38**2&&score>best){candidate=p;best=score;}}
      if(!candidate)break;centers.push({rgb:[...candidate.rgb]});
    }
    for(let pass=0;pass<5;pass++){
      const sums=centers.map(()=>({rgb:[0,0,0],weight:0}));
      for(const p of points){const b=sums[nearest(p.rgb,centers)];b.weight+=p.weight;for(let c=0;c<3;c++)b.rgb[c]+=p.rgb[c]*p.weight;}
      centers.forEach((c,i)=>{if(sums[i].weight){c.rgb=sums[i].rgb.map(v=>Math.round(v/sums[i].weight));c.weight=sums[i].weight;}});
    }
    return centers.filter(c=>c.weight).sort((a,b)=>b.weight-a.weight).map(c=>({...c,hex:hex(c.rgb),mode:'off'}));
  }
  function prepare(image) {
    const canvas=document.createElement('canvas'),ratio=Math.min(1,900/Math.max(image.naturalWidth,image.naturalHeight));
    canvas.width=Math.max(1,Math.round(image.naturalWidth*ratio));canvas.height=Math.max(1,Math.round(image.naturalHeight*ratio));
    const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0,canvas.width,canvas.height);
    const pixels=ctx.getImageData(0,0,canvas.width,canvas.height);
    const sample=document.createElement('canvas'),scale=Math.min(1,256/Math.max(canvas.width,canvas.height));
    sample.width=Math.max(1,Math.round(canvas.width*scale));sample.height=Math.max(1,Math.round(canvas.height*scale));
    const small=sample.getContext('2d',{willReadFrequently:true});small.drawImage(canvas,0,0,sample.width,sample.height);
    const palette=detect(small.getImageData(0,0,sample.width,sample.height).data);
    const labels=new Uint8Array(canvas.width*canvas.height),cache=new Map();
    for(let i=0;i<pixels.data.length;i+=4){
      if(!pixels.data[i+3])continue;
      const rgb=[pixels.data[i],pixels.data[i+1],pixels.data[i+2]],id=(rgb[0]>>3)*1024+(rgb[1]>>3)*32+(rgb[2]>>3);
      if(!cache.has(id))cache.set(id,nearest(rgb,palette));labels[i/4]=cache.get(id);
    }
    return {width:canvas.width,height:canvas.height,pixels,labels,palette};
  }
  function mask(source, modes, treatment) {
    const canvas=document.createElement('canvas');canvas.width=source.width;canvas.height=source.height;
    const ctx=canvas.getContext('2d'),out=ctx.createImageData(source.width,source.height);
    for(let i=0;i<out.data.length;i+=4){
      out.data[i]=out.data[i+1]=out.data[i+2]=255;
      out.data[i+3]=modes[source.labels[i/4]]===treatment?source.pixels.data[i+3]:0;
    }
    ctx.putImageData(out,0,0);return canvas;
  }
  return {detect,prepare,mask,nearest};
})();
